import * as React from 'react';

class TestTextInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            valore: "Roberto"
        };

        this.handleChange = this.handleChange.bind(this);
        this.invia = this.invia.bind(this);
        this.componentName = "[TestTextInput.jsx] ";
    }

    handleChange(event) {
        const target = event.target;
        // const value = target.name === 'first' ? target.value : target.value;
        const name = target.name;
        //this.state.cognome = "Rutigliano";

        console.log('name: ' + target.name + " value: " + target.value);

        if (name === "first") {
            this.setState({ value: target.value });
        }
        else if (name === "second") {
            this.setState({ value2: target.value });
        }
        else {
            this.setState({ cognome: target.value });
        }

    }
    invia() {
        let log = document.getElementById('log');
        log.insertAdjacentHTML('beforeend', '<h1> first </h1> ' + this.state.value);
        log.insertAdjacentHTML('beforeend', '<h1> second </h1> ' + this.state.value2);
        log.insertAdjacentHTML('beforeend', '<h1> cognome </h1> ' + this.state.cognome);
        {/*alert('value1 ' + this.state.value + ' :::: ' + ' value2 ' + this.state.value2);
        event.preventDefault();*/}
    }
    render() {
        console.log(this.componentName + "render");
        return (
            <div>
                <p>esempio di utilizzo della semplice input type="text"</p>
                <div className="form-group">
                    <input type="text" name="first" value={this.state.value} onChange={this.handleChange} />
                    <br /> <br />
                    <input type="text" name="second" value={this.state.value2} onChange={this.handleChange} />
                    <br />  <br />
                    <input type="text" name="cognome" value={this.state.cognome} onChange={this.handleChange} />
                    <br />  <br />
                    <button className="btn btn-info" onClick={this.invia}> Invia </button>
                    <div id="log"></div>
                </div>

            </div>

        );
    }
}

export default TestTextInput;